import styled from "@emotion/styled";

const Overlay = styled.div`
  z-index: 1000;

  body {
    overflow: none;
  }

  background: #00000090;
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
`;

const ModalWrapper = styled.div`
  background: #1d2029;
  border: 1px solid #1d2029;
  border-radius: 0.5rem;
  box-shadow: 0px 4px 8px 4px #0000002e;
  margin: 15vh auto;
  min-width: 300px;
  min-height: 200px;
  padding: 1rem;
  position: relative;
  width: fit-content;
`;

const CloseButton = styled.button`
  cursor: pointer;
  border: none;
  background: #fff;
  border-radius: 1rem;
  outline: none;
  height: 1rem;
  padding: 0;
  position: absolute;
  right: 0.5rem;
  top: 0.5rem;
  line-height: 0;
  width: 1rem;
  font-family: monospace;

  &:hover {
    background-color: #ffffffAA;
  }
`;

function Modal({
  children,
  closeModal,
}: {
  children: React.ReactChild;
  closeModal: any;
}) {
  return (
    <Overlay>
      <ModalWrapper>
        <>
          <CloseButton
            onClick={closeModal}
            dangerouslySetInnerHTML={{ __html: "&Cross;" }}
          />
          {children}
        </>
      </ModalWrapper>
    </Overlay>
  );
}

export default Modal;
